import { format, isValid, parseISO } from 'date-fns';

export const formatDollar = (amount: number): string =>
  `$${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const formatDepartmentGroups = (groups: string[]): string =>
  groups.length > 0 ? groups.join(', ') : '—';

export const formatOptionalDate = (isoLike: string | null): string => {
  if (!isoLike) return '—';
  try {
    const date = parseISO(isoLike);
    return isValid(date) ? format(date, 'MMM d, yyyy') : isoLike;
  } catch {
    return isoLike;
  }
};
